import React, { useContext } from "react";

import useHttp from "../../../../hooks/useHttp";
import {
  ACCEPT_COUNTER_OFFER_URL,
  REJECT_COUNTER_OFFER_URL,
  STOP_COUNTER_OFFER_URL,
} from "../../../../utils/api-ends";
import LoaderImg from "../../../../assets/media/loader.gif";
import { ManageLoadPostDetailPageContext } from "../";

const CarrierCounterOfferArea = () => {
  const { isLoading: loadingAcceptOffer, sendRequests: acceptOfferRequest } =
    useHttp();
  const { isLoading: loadingRejectOffer, sendRequests: rejectOfferRequest } =
    useHttp();
  const { isLoading: loadingStopOffer, sendRequests: stopOfferRequest } =
    useHttp();
  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );
  const carrierLoadPostActivity = loadPostDetailState.carrierActivity;

  const handleAcceptCounterOffer = () => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_ACCEPT_COUNTER_OFFER",
      });
    };
    acceptOfferRequest(
      {
        url: ACCEPT_COUNTER_OFFER_URL(carrierLoadPostActivity?.id),
        method: "patch",
      },
      response
    );
  };

  const handleRejectCounterOffer = () => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_REJECT_COUNTER_OFFER",
      });
    };
    rejectOfferRequest(
      {
        url: REJECT_COUNTER_OFFER_URL(carrierLoadPostActivity?.id),
        method: "patch",
      },
      response
    );
  };

  const handleStopCounterOffer = () => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_STOP_COUNTER_OFFER",
      });
    };
    stopOfferRequest(
      {
        url: STOP_COUNTER_OFFER_URL(carrierLoadPostActivity?.id),
        method: "patch",
      },
      response
    );
  };

  const openCounterModal = () => {
    loadPostDetailContextDispatch({
      type: "OPEN_COUNTER_MODAL",
      payload: {
        data: {
          id: carrierLoadPostActivity?.id,
          amount: carrierLoadPostActivity?.counter_amount,
        },
        openFrom: "carrier_page",
      },
    });
  };

  return (
    <section className="loads-details-alerts">
      <div className="container theme-section">
        <p className="large-text">
          {carrierLoadPostActivity?.counter_offer_by === "me"
            ? `You sent a counter offer For $${carrierLoadPostActivity?.counter_amount}`
            : `Shipper sent you a counter offer For $${carrierLoadPostActivity?.counter_amount}`}
        </p>
        <p>Counter Status: {carrierLoadPostActivity?.counter_status_display}</p>
        <p>
          Is Amount Fixed:{" "}
          {carrierLoadPostActivity?.is_counter_amount_fixed === true
            ? "Yes"
            : "No"}
        </p>

        <div className="multiple-btn flex-direction-initial mt-4 flex-wrap">
          {carrierLoadPostActivity?.counter_status === "in_progress" &&
            carrierLoadPostActivity?.counter_offer_by === "other" && (
              <>
                <button
                  disabled={
                    loadingAcceptOffer || loadingRejectOffer || loadingStopOffer
                  }
                  className="m-0"
                  onClick={handleAcceptCounterOffer}
                >
                  Accept Offer
                  {loadingAcceptOffer && (
                    <img
                      style={{ width: "22px" }}
                      src={LoaderImg}
                      alt="loader"
                    />
                  )}
                </button>
                <button
                  disabled={
                    loadingAcceptOffer || loadingRejectOffer || loadingStopOffer
                  }
                  className="m-0"
                  onClick={handleRejectCounterOffer}
                >
                  Reject Offer
                  {loadingRejectOffer && (
                    <img
                      style={{ width: "22px" }}
                      src={LoaderImg}
                      alt="loader"
                    />
                  )}
                </button>
                <button
                  disabled={
                    loadingAcceptOffer || loadingRejectOffer || loadingStopOffer
                  }
                  className="m-0"
                  onClick={handleStopCounterOffer}
                >
                  Stop Counter Offer
                  {loadingStopOffer && (
                    <img
                      style={{ width: "22px" }}
                      src={LoaderImg}
                      alt="loader"
                    />
                  )}
                </button>
              </>
            )}

          {carrierLoadPostActivity?.can_counter && (
            <button className="m-0" onClick={openCounterModal}>
              Send New Offer
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default CarrierCounterOfferArea;
